module.exports = __webpack_public_path__ + "img/logo.1c834697.png";